import { gql } from '@apollo/client';
import gqlClient from '../../../../utils/apolloClient';

const updateCaseEventMutation = gql`
  mutation ($pk_columns: case_events_pk_columns_input!, $set: case_events_set_input!) {
    update_case_events_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
  }
`;

export const updateCaseEvent = async (variables: object) => {
  const res =  await gqlClient.mutate<{
    update_case_events_by_pk: {
      id: string,
    }
  }>({ mutation: updateCaseEventMutation!, variables });
  return res.data?.update_case_events_by_pk.id;
}

const uupdateCaseAccessionNumberMutation = gql`
  mutation ($pk_columns: cases_pk_columns_input!, $set: cases_set_input!) {
    update_cases_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
  }
`;

export const updateCaseAccessionNumber = async (variables: object) => {
  const res =  await gqlClient.mutate<{
    update_cases_by_pk: {
      id: string,
    }
  }>({ mutation: uupdateCaseAccessionNumberMutation!, variables });
  return res.data?.update_cases_by_pk.id;
}

const updateCaseEventsAccessionNumberMutation = gql`
  mutation ($case_id: uuid, $set: case_events_set_input) {
    update_case_events(where: {case_id: {_eq: $case_id}}, _set: $set) {
      affected_rows
    }
  }
`;

export const updateCaseEventsAccessionNumber = async (variables: object) => {
  const res =  await gqlClient.mutate<{
    update_case_events: {
      affected_rows: number,
    }
  }>({ mutation: updateCaseEventsAccessionNumberMutation!, variables });
  return res.data?.update_case_events.affected_rows;
}
